var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"loader",attrs:{"id":"widgetLoader"}}),(_vm.message)?_c('p',{staticClass:"spinnerMessage"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }